import { _T, C } from '../../shared/theme';

function RingGauge({value,label,color,size=72}) {
  const r=28,cx=size/2,cy=size/2,circ=2*Math.PI*r,offset=circ*(1-Math.min(value,100)/100);
  return (
    <div style={{textAlign:"center"}}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle cx={cx} cy={cy} r={r} fill="none" stroke={_T.bg4} strokeWidth={6}/>
        <circle cx={cx} cy={cy} r={r} fill="none" stroke={color} strokeWidth={6} strokeDasharray={circ} strokeDashoffset={offset} strokeLinecap="round" transform={`rotate(-90 ${cx} ${cy})`}/>
        <text x={cx} y={cy+4} textAnchor="middle" fill={color} fontSize={11} fontWeight="700" fontFamily="Inter">{Math.round(value)}%</text>
      </svg>
      <div style={{fontSize:9,color:C.silver,textTransform:"uppercase",fontWeight:500,marginTop:2}}>{label}</div>
    </div>
  );
}

export default RingGauge;
